import { render, staticRenderFns } from "./IssueProbabilityTableCell.vue?vue&type=template&id=5f21efe1&scoped=true"
import script from "./IssueProbabilityTableCell.vue?vue&type=script&lang=js"
export * from "./IssueProbabilityTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f21efe1",
  null
  
)

export default component.exports